/// <reference types="vite/client" />
/**
 * API routing abstraction layer.
 *
 * Currently always returns the cloud base URL.
 * Extension point: when local AI sidecar support is added, agent/LLM
 * endpoints can be routed to localhost while auth/billing stay on cloud.
 */

type ApiTarget = 'cloud'; // Future: | 'local'

const CLOUD_API_BASE_URL: string = (() => {
  const envVal = (
    import.meta.env.VITE_API_BASE_URL ||
    import.meta.env.VITE_PLUGIN_API_BASE_URL ||
    import.meta.env.VITE_AGENT_API_BASE_URL ||
    ''
  ).trim().replace(/\/+$/, '');

  if (envVal) return envVal;

  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname.toLowerCase();
    if (hostname === 'dev.askyour.ai') return 'https://api-dev.askyour.ai';
    if (hostname === 'askyour.ai' || hostname === 'www.askyour.ai') {
      return 'https://api.askyour.ai';
    }
    // Tauri desktop renders under `tauri.localhost`; route to hosted prod API.
    // B2B on-prem builds inject VITE_API_BASE_URL instead and never reach this branch.
    if (hostname === 'tauri.localhost') return 'https://api.askyour.ai';
  }
  return '';
})();

export function resolveBaseUrl(
  _endpoint: string,
  _target: ApiTarget = 'cloud',
): string {
  // Phase 1: always cloud
  return CLOUD_API_BASE_URL;

  // Future local routing:
  // const LOCAL_ENDPOINTS = ['/api/v1/agent/', '/api/v1/workspaces/', '/api/v1/llm/'];
  // if (_target === 'local' && LOCAL_ENDPOINTS.some(p => _endpoint.startsWith(p))) {
  //   return 'http://localhost:9205';
  // }
  // return CLOUD_API_BASE_URL;
}

export function getCloudApiBaseUrl(): string {
  return CLOUD_API_BASE_URL;
}
